import { render, staticRenderFns } from "./daigongxq.vue?vue&type=template&id=2ddde553&scoped=true&"
import script from "./daigongxq.vue?vue&type=script&lang=js&"
export * from "./daigongxq.vue?vue&type=script&lang=js&"
import style0 from "./daigongxq.vue?vue&type=style&index=0&id=2ddde553&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddde553",
  null
  
)

export default component.exports